import './App.css';
import { AllRoutes } from './Components/AllRoutes';

function App() {
  return (
    <div id="App">
     <AllRoutes/>
    </div>
  );
}

export default App;
